/// <reference path="../../../../app.definition.ts" />


import angular from "angular";
import _ from "lodash";
import {CacheService} from "@common/service/cache.service";
import { IAppRootScopeService } from "@/app/app.definition";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {PopUpService} from "@common/popup/popup.service";
import {DocumentFolderService} from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import {CachingService} from "@common/service/caching.service";
import { UtilityService } from "@common/service/util.service";
import { PostTypeEnums } from "@common/model/_adocument";
import {DocumentFolder, FolderStatusCodes, FolderTypeCodes} from "@common/model/documentFolder";
import {Util} from "@common/util";
import { MENU_ACTIONS } from "@common/model/constants";


export class FolderOperationsPopupController {
    static $inject = ["$q", "CacheService", "$uibModalInstance", "$injector", "$rootScope", "$timeout", "ApiAdapterService", "PopUpService",
        "DocumentFolderService", "operation", "postType", "currentFolder", "UtilityService", "CachingService"];

    constructor($q : ng.IQService, $_cache : CacheService, $uibModalInstance : ng.ui.bootstrap.IModalServiceInstance, $injector:ng.auto.IInjectorService, $rootScope : IAppRootScopeService, $timeout : ng.ITimeoutService, ApiAdapterService : JavaApiAdapterService, PopUpService : PopUpService,
                $_docFolderSvc : DocumentFolderService, operation : String, postType : String, currentFolder : DocumentFolder, UtilityService : UtilityService, CachingService : CachingService) {
        let fldrOpVm: any = this;
        fldrOpVm.$validationProvider = $injector.get('$validation');

        var popupWords = {
            "create": {
                "title": "Create New Folder"
            },
            "rename": {
                "title": "Rename Folder"
            },
            "move": {
                "title": "Move Folder"
            },
            "copy": {
                "title": "Copy Document"
            }
        }

        fldrOpVm.currentFolder = currentFolder;
        fldrOpVm.rootFolder = $_docFolderSvc.fetchRootFolder();
        fldrOpVm.operation = operation;
        fldrOpVm.postType = postType;
        fldrOpVm.beforeMoveFolder = null;
        fldrOpVm.beforeRenameFolder = null;
        fldrOpVm.MENU_ACTIONS = MENU_ACTIONS;
        fldrOpVm.doubleClick = null;
        fldrOpVm.folderArray = [];
        fldrOpVm.typeCodes = FolderTypeCodes;
        fldrOpVm.tmFldrMsg = "You are unable to move Team documents and folders outside of that Team’s folder.";
        fldrOpVm.rsFldrMsg = "You are unable to move Resource Library documents outside of Resource Library folder.";

        fldrOpVm.init = () => {
            fldrOpVm.user = $_cache.getUser();
            fldrOpVm.currentOperation = popupWords[fldrOpVm.operation];
            if (fldrOpVm.operation == MENU_ACTIONS.RENAME) {
                //to set model to popup
                fldrOpVm.folder = angular.copy(currentFolder);
                fldrOpVm.beforeRenameFolder = fldrOpVm.folder.name;
            } else if (fldrOpVm.operation == MENU_ACTIONS.MOVE) {
                fldrOpVm.folder = angular.copy(currentFolder);
                if (!!fldrOpVm.postType) {
                    !!fldrOpVm.folder.title && (fldrOpVm.folder.name = fldrOpVm.folder.title);
                    fldrOpVm.beforeMoveFolder = $_docFolderSvc.fetchFolderById(fldrOpVm.folder.documentFolderId);
                    fldrOpVm.setParentFolder(fldrOpVm.folder.documentFolderId);
                    fldrOpVm.postType = UtilityService.toTitleCase(fldrOpVm.folder.postType);
                    fldrOpVm.currentOperation.title = "Move " + UtilityService.toTitleCase(fldrOpVm.postType);
                    fldrOpVm.isResourceDoc = (fldrOpVm.beforeMoveFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY || fldrOpVm.beforeMoveFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY_CHILD);
                } else {
                    fldrOpVm.beforeMoveFolder = $_docFolderSvc.fetchFolderById(fldrOpVm.folder.parentId);
                    fldrOpVm.setParentFolder(fldrOpVm.folder.parentId);
                }
                fldrOpVm.folder.moveToFolder = fldrOpVm.beforeMoveFolder;
                angular.element('.full-button').focus();
              } else if (fldrOpVm.operation == MENU_ACTIONS.COPY) {
                fldrOpVm.folder = angular.copy(currentFolder);
                if (!!fldrOpVm.postType) {
                    !!fldrOpVm.folder.title && (fldrOpVm.folder.name = fldrOpVm.folder.title);
                    fldrOpVm.beforeMoveFolder = $_docFolderSvc.fetchFolderById(fldrOpVm.folder.documentFolderId);
                    fldrOpVm.setParentFolder(fldrOpVm.rootFolder.id, null, fldrOpVm.operation);
                    fldrOpVm.postType = UtilityService.toTitleCase(fldrOpVm.folder.postType);
                    fldrOpVm.currentOperation.title = "Copy " + UtilityService.toTitleCase(fldrOpVm.postType);
                    fldrOpVm.isResourceDoc = (fldrOpVm.beforeMoveFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY || fldrOpVm.beforeMoveFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY_CHILD);
                } else {
                    fldrOpVm.beforeMoveFolder = $_docFolderSvc.fetchFolderById(fldrOpVm.folder.parentId);
                    fldrOpVm.setParentFolder(fldrOpVm.folder.parentId);
                }
                fldrOpVm.folder.moveToFolder = fldrOpVm.rootFolder;
                angular.element('.full-button').focus();
            }
        }

        //select requireMoveToFolder
        fldrOpVm.selectMoveFolder = (folder : DocumentFolder) => {
            $timeout(function () {
                if (!fldrOpVm.doubleClick) {
                    fldrOpVm.folder.moveToFolder = folder;
                    fldrOpVm.doubleClick = false;
                }
            }, 200);
        }

        fldrOpVm.cancelSelection = () => {
            if (fldrOpVm.operation == MENU_ACTIONS.RENAME) {
                fldrOpVm.folder.name = fldrOpVm.beforeRenameFolder;
            } else if (fldrOpVm.operation == MENU_ACTIONS.MOVE) {
                fldrOpVm.folder.moveToFolder = fldrOpVm.beforeMoveFolder;
            }
            if (!!fldrOpVm.postType) {
                if (fldrOpVm.operation == MENU_ACTIONS.COPY) {
                    fldrOpVm.setParentFolder(fldrOpVm.rootFolder.id);
                } else {
                    fldrOpVm.setParentFolder(fldrOpVm.folder.documentFolderId);
                }
            } else {
                fldrOpVm.setParentFolder(fldrOpVm.folder.parentId);
            }
            $('.full-button').click();
        }

        fldrOpVm.selectionDone = () => {
            $('.full-button').click();
        }

        fldrOpVm.getFolder = (folderId : number) => {
            let fldr = fldrOpVm.folderArray.find(f => f.id == folderId);
            if (!fldr) {
                fldr = $_docFolderSvc.fetchFolderById(folderId);
            }
            return fldr;
        }

        fldrOpVm.getAllChildFolders = (folderId : number, subId:number) => {
            let isEntDocOrFldr = (!fldrOpVm.postType || _.includes([PostTypeEnums.DOCUMENT, PostTypeEnums.LINK], fldrOpVm.postType)) && fldrOpVm.user.organizationId > 0;
            let factor = !!fldrOpVm.postType ? FolderStatusCodes.DOC_MOVE_IN : FolderStatusCodes.SUB_FOLDER_MOVE_IN;
            let isNormalDocMoveAction = fldrOpVm.postType && _.includes([PostTypeEnums.DOCUMENT.toLowerCase(), PostTypeEnums.LINK.toLowerCase()], fldrOpVm.postType.toLowerCase()) && fldrOpVm.operation == MENU_ACTIONS.MOVE && fldrOpVm.folder.subjectId;
            $_docFolderSvc.getAllChildFolders(folderId, subId).then((s : any) => {
                if (fldrOpVm.operation == MENU_ACTIONS.COPY) {
                    fldrOpVm.folderStructureFiltered = s.filter((item) => {
                        return item.folderType == 'PERSONAL'
                    });
                } else {
                    fldrOpVm.folderStructureFiltered = s.filter((item) => {
                        return $_docFolderSvc.isActionAllowed(item.allowedOperation, factor) && (!isEntDocOrFldr || item.subjectId == fldrOpVm.folder.subjectId) && item.id != fldrOpVm.currentFolder.id;
                    });
                    if (isNormalDocMoveAction) {
                        fldrOpVm.folderStructureFiltered = fldrOpVm.folderStructureFiltered.filter((item : DocumentFolder) => {
                            return !_.includes([FolderTypeCodes.RESOURCE_LIBRARY, FolderTypeCodes.RESOURCE_LIBRARY_CHILD], item.folderType);
                        });
                    }
                }

                fldrOpVm.folderArray = fldrOpVm.folderArray.concat(fldrOpVm.folderStructureFiltered);
                fldrOpVm.foldersLoaded = true;
            });
        }

        //call on right arrow click for move folder dropdown
        fldrOpVm.setParentFolder = (folderId : number, dblClick : Boolean) => {
            fldrOpVm.foldersLoaded = false;
            fldrOpVm.folderStructureFiltered = [];
            if (!!dblClick) {
                fldrOpVm.doubleClick = true;
            }
            let thisFldr = fldrOpVm.getFolder(folderId);
            if (folderId != 0) {
                fldrOpVm.currentParent = fldrOpVm.folder.moveToFolder = thisFldr;
            }

            let resp = fldrOpVm.folderArray.filter(f => f.parentId == folderId);
            if (resp.length > 0 || thisFldr['childCount'] == 0) {
                fldrOpVm.folderStructureFiltered = resp;
                fldrOpVm.foldersLoaded = true;
            } else {
                let subId = (thisFldr.folderType == FolderTypeCodes.ENTERPRISE_TEAMS) ? fldrOpVm.folder.subjectId : null;
                fldrOpVm.getAllChildFolders(folderId, subId);
            }
            $timeout(function () {
                if (!!dblClick) {
                    fldrOpVm.doubleClick = false;
                }
            }, 500);
        }

        //call on left arrow click for move folder dropdown
        fldrOpVm.setAsChildFolder = (folderId : number) => {
            fldrOpVm.foldersLoaded = false;
            fldrOpVm.folderStructureFiltered = [];
            let prntFldr : DocumentFolder;
            let thisFldr = fldrOpVm.getFolder(folderId);
            if (thisFldr.parentId != 0) {
                prntFldr = fldrOpVm.getFolder(thisFldr.parentId);
                fldrOpVm.currentParent = fldrOpVm.folder.moveToFolder = prntFldr;
            }

            let resp = fldrOpVm.folderArray.filter(f => f.parentId == thisFldr.parentId);
            if (resp.length > 0 || (!!prntFldr && prntFldr['childCount'] == 0)) {
                fldrOpVm.folderStructureFiltered = resp;
                fldrOpVm.foldersLoaded = true;
            } else {
                let subId = (!!prntFldr && prntFldr.folderType == FolderTypeCodes.ENTERPRISE_TEAMS) ? fldrOpVm.folder.subjectId : null;
                fldrOpVm.getAllChildFolders(thisFldr.parentId, subId);
            }
        }

        fldrOpVm.folderNameChanged = () => {
            fldrOpVm.folderNameError = "";
        }

        fldrOpVm.operate = (folderOperationsForm : any) => {
            let deferred = $q.defer();
            fldrOpVm.folderNameError = "";
            fldrOpVm.$validationProvider.validate(folderOperationsForm)
                .success(() => {
                    fldrOpVm.folder.name = fldrOpVm.folder.name.replace(/\s\s+/g, ' ');
                    if (fldrOpVm.operation == MENU_ACTIONS.CREATE) {
                        //If the folder is created inside the RL or RL child folder, then set the folder type to RESOURCE_LIBRARY_CHILD.
                        if (fldrOpVm.currentFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY || fldrOpVm.currentFolder.folderType == FolderTypeCodes.RESOURCE_LIBRARY_CHILD) {
                            fldrOpVm.folder.folderType = FolderTypeCodes.RESOURCE_LIBRARY_CHILD;
                        } else {
                            fldrOpVm.folder.folderType = (!!_.includes([FolderTypeCodes.SYSTEM_SUBJECT, FolderTypeCodes.SUBJECT], fldrOpVm.currentFolder.folderType)) ? FolderTypeCodes.SUBJECT : FolderTypeCodes.PERSONAL;
                        }
                        let folderModel = {
                            "name": fldrOpVm.folder.name,
                            "parentId": fldrOpVm.currentFolder.id,
                            "documentType": fldrOpVm.currentFolder.documentType,
                            "folderType": fldrOpVm.folder.folderType,
                            "subjectId": fldrOpVm.currentFolder.subjectId
                        };
                        $rootScope.mainShowLoader = true;
                        ApiAdapterService.createFolder(fldrOpVm.user.id, folderModel).then(
                            (s : DocumentFolder) => {
                                $uibModalInstance.close(s);
                                let success_msg = Util.FOLDER_CREATED_SUCCESSFULLY;
                                toastr.success(success_msg, "");
                                deferred.resolve();
                            },
                            e => {
                                //PopUpService.openInformationModal(e, null, null, null, true).then((s) => { });
                                fldrOpVm.folderNameError = e;
                                console.log(e);
                                deferred.reject();
                            }
                        ).finally(() => {
                            $rootScope.mainShowLoader = false;
                        });
                    } else if (fldrOpVm.operation == MENU_ACTIONS.RENAME) {
                        if (fldrOpVm.folder.name != fldrOpVm.beforeRenameFolder) {
                            let folderModel = {
                                "name": fldrOpVm.folder.name,
                                "parentId": fldrOpVm.folder.parentId
                            }
                            $rootScope.mainShowLoader = true;
                            ApiAdapterService.updateFolder(fldrOpVm.user.id, fldrOpVm.folder.id, folderModel).then(
                                (s : DocumentFolder) => {
                                    $uibModalInstance.close(s);
                                    let success_msg = Util.FOLDER_RENAMED_SUCCESSFULLY;
                                    toastr.success(success_msg, "");
                                    deferred.resolve();
                                },
                                e => {
                                    //PopUpService.openInformationModal(e, null, null, null, true).then((s) => { });
                                    fldrOpVm.folderNameError = e;
                                    console.log(e);
                                    deferred.reject();
                                }
                            ).finally(() => {
                                $rootScope.mainShowLoader = false;
                            });
                        } else {
                            deferred.reject();
                        }
                    } else if (fldrOpVm.operation == MENU_ACTIONS.MOVE && !fldrOpVm.postType) {
                        if (fldrOpVm.folder.moveToFolder != fldrOpVm.beforeMoveFolder) {
                            let folderModel = {
                                "name": fldrOpVm.folder.name,
                                "parentId": fldrOpVm.folder.moveToFolder.id
                            }
                            $rootScope.mainShowLoader = true;
                            ApiAdapterService.updateFolder(fldrOpVm.user.id, fldrOpVm.folder.id, folderModel).then(
                                (s : DocumentFolder) => {
                                    $uibModalInstance.close(s);
                                    let success_msg = Util.FOLDER_MOVED_SUCCESSFULLY;
                                    toastr.success(success_msg, "");
                                    deferred.resolve();
                                },
                                e => {
                                    //PopUpService.openInformationModal(e, null, null, null, true).then((s) => { });
                                    fldrOpVm.folderNameError = e;
                                    console.log(e);
                                    deferred.reject();
                                }
                            ).finally(() => {
                                $rootScope.mainShowLoader = false;
                            });
                        } else {
                            fldrOpVm.dismiss();
                            deferred.reject();
                        }
                    } else if (fldrOpVm.operation == MENU_ACTIONS.MOVE && !!fldrOpVm.postType) {
                        if (fldrOpVm.folder.moveToFolder != fldrOpVm.beforeMoveFolder) {
                            var folderModel = {
                                "id": fldrOpVm.folder.id,
                                "name": fldrOpVm.folder.name,
                                "parentId": fldrOpVm.folder.moveToFolder.id,
                                "postType": fldrOpVm.folder.postType
                            }
                            $rootScope.mainShowLoader = true;
                            ApiAdapterService.moveDocument(folderModel).then(
                                () => {
                                    $uibModalInstance.close({"parentId": fldrOpVm.folder.moveToFolder.id});
                                    let success_msg = Util.DOCUMENT_MOVED_SUCCESSFULLY;
                                    toastr.success(success_msg, "");
                                    deferred.resolve();
                                },
                                e => {
                                    //PopUpService.openInformationModal(e, null, null, null, true).then((s) => { });
                                    fldrOpVm.folderNameError = e;
                                    console.log(e);
                                    deferred.reject();
                                }
                            ).finally(() => {
                                $rootScope.mainShowLoader = false;
                            });
                        } else {
                            fldrOpVm.dismiss();
                            deferred.reject();
                        }
                    } else if (fldrOpVm.operation == MENU_ACTIONS.COPY && !!fldrOpVm.postType) {
                        if (fldrOpVm.folder.moveToFolder != fldrOpVm.beforeMoveFolder) {
                            var copyFolderModel = {
                                "id": fldrOpVm.folder.id,//docID
                                "userId": fldrOpVm.user.id,
                                "folderId": fldrOpVm.folder.moveToFolder.id, //copy to folder ID
                                "postType": fldrOpVm.folder.postType // post type of the document.
                            }
                            $rootScope.mainShowLoader = true;
                            CachingService.resetCachedFolderFeedsUsingId(fldrOpVm.folder.moveToFolder.id);
                            ApiAdapterService.copyDocument(copyFolderModel).then(
                                () => {
                                    $uibModalInstance.close({"parentId": fldrOpVm.folder.moveToFolder.id});
                                    let success_msg = Util.DOCUMENT_COPIED_SUCCESSFULLY;
                                    toastr.success(success_msg, "");
                                    deferred.resolve();
                                },
                                e => {
                                    fldrOpVm.folderNameError = e;
                                    console.log(e);
                                    deferred.reject();
                                }
                            ).finally(() => {
                                $rootScope.mainShowLoader = false;

                            });
                        } else {
                            fldrOpVm.dismiss();
                            deferred.reject();
                        }
                    } else {
                        console.log("invalid operation");
                        deferred.reject();
                    }
                }).error(function (message : String) {
                console.log("Validation Error:", message);
                deferred.reject();
            });
            return deferred.promise;
        }

        fldrOpVm.dismiss = () => {
            $uibModalInstance.dismiss();
        }

        fldrOpVm.init();
    }

}

angular.module('eCareVault.common.itemBoard')
    .controller('FolderOperationsPopupController', FolderOperationsPopupController);
